import { render } from "./imgUpload.vue?vue&type=template&id=f05e3748&scoped=true"
import script from "./imgUpload.vue?vue&type=script&lang=js"
export * from "./imgUpload.vue?vue&type=script&lang=js"

import "./imgUpload.vue?vue&type=style&index=0&id=f05e3748&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05e3748"]])

export default __exports__